import React from 'react';

import { LoanBanner } from './index';

export const IncompleteSettlement: React.FC = () => (
  <LoanBanner>
    <span>This loan is currently on a settlement. Your loan details and terms may have changed.</span>
  </LoanBanner>
);
